import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Audience } from './components/Audience';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Alongside } from './components/Alongside';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// import { PurchaseNotifications } from './components/PurchaseNotifications'
// Mount <PurchaseNotifications /> again once data/recentPurchases.ts is fed by real orders.

export function App() {
  return <div className="min-h-screen w-full bg-navy font-sans text-chalk selection:bg-hl selection:text-hl-ink" data-id="element-0" data-mp="3rd18nfm3z7mg">
      <MetaPixel data-id="element-1" data-mp="82ovg3doih9" />
      <main data-id="element-2" data-mp="2zl3cxocsjc6w">
        <Hero data-id="element-3" data-mp="2zllen0i82im7" />
        <SocialProofBar data-id="element-4" data-mp="2zm4y4lnitf2c" />
        <PainGrid data-id="element-5" data-mp="2zmo5x9jgin2n" />
        <ProductReveal data-id="element-6" data-mp="2zn66ujh2dpgw" />
        <Tomes data-id="element-7" data-mp="33mf1dqjxhrdi" />
        <PageCarousel data-id="element-8" data-mp="33lwyib2rgewm" />
        <Bonuses data-id="element-9" data-mp="33ngfy505kvzz" />
        <ValueStack data-id="element-10" data-mp="33mylndx1wrup" />
        <Urgency data-id="element-11" data-mp="38lromcepp0gm" />
        <Pricing data-id="element-12" data-mp="38l8hzruihyhw" />
        {/* Real reviews replace "Who it's for" as soon as data/testimonials.ts has entries */}
        {shortTestimonials.length > 0 ? <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="dark" data-id="element-13" data-mp="3dirv2ofh4589" /> : <Audience data-id="element-14" data-mp="nxwupdpa56s0" />}
        <Guarantee data-id="element-15" data-mp="su427axbqqc2" />
        <Faq data-id="element-16" data-mp="stc9c7v436ph" />
        {moreTestimonials.length > 0 ? <Testimonials testimonials={moreTestimonials} title="Works alongside your program" subtitle="Coaches use it to turn the drills they already know into a full practice for every group." background="mid" data-id="element-17" data-mp="36859fxwiety" /> : <Alongside data-id="element-18" data-mp="d2bhjemgvtum" />}
        <CostOfInaction data-id="element-19" data-mp="851hl51gbzsj" />
        <Close data-id="element-20" data-mp="86w60tbxma1d" />
      </main>
      <Footer data-id="element-21" data-mp="83i0xdbvvmq8" />
    </div>;
}